import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-professional-ranking-classif',
  templateUrl: './professional-ranking-classif.component.html',
  styleUrls: ['./professional-ranking-classif.component.scss']
})

export class ProfessionalRankingClassifComponent implements OnInit {
  /**
   * Definição para receber o identificador do ranking
   */
  rankingId: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
      this.rankingId = this.route.snapshot.paramMap.get('rankingId');
  }
}
